module.exports = __webpack_public_path__ + "img/kontakt_960.6143b106.webp";